module.exports = __webpack_public_path__ + "static/media/post.7eac5d5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/post.mp3
// module id = 6A8z
// module chunks = 1 3